
import React from "react";
import { AlertCircle, RefreshCw } from "lucide-react";
// import { ActionButton } from "./ActionButton";
import { ActionButton } from "../ui/ActionButton";

export const ErrorState = ({ message, onRetry }) => (
  <div className="bg-white rounded-xl shadow-sm overflow-hidden">
    <div className="bg-gradient-to-r from-red-500 to-pink-600 p-4 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent"></div>
      <div className="relative z-10 flex items-center gap-3">
        <AlertCircle className="w-5 h-5 text-white" />
        <h2 className="text-xl font-bold text-white">Error Loading Projects</h2>
      </div>
      <div className="absolute -top-4 -right-4 w-12 h-12 bg-white/10 rounded-full"></div>
      <div className="absolute -bottom-2 -left-2 w-8 h-8 bg-white/10 rounded-full"></div>
    </div>
    <div className="p-6 text-center">
      <p className="text-slate-600 mb-4">{message}</p>
      {onRetry && (
        <ActionButton onClick={onRetry} variant="primary">
          <RefreshCw className="w-4 h-4 mr-2" />
          Try Again
        </ActionButton>
      )}
    </div>
  </div>
);